module.exports = __webpack_public_path__ + "img/jn-active.7db9c1f4.png";